import { Flex, Text } from '@approvalmax/ui/src/components';
import { backend } from 'modules/data';
import { memo, useMemo } from 'react';

import {
    fieldAppearanceAddress,
    fieldAppearanceBankDetails,
    stepOneRenderedKeys,
    stepTwoRenderedKeys,
} from '../../AddBeneficiaryPopupContent.constants';
import { Fields } from '../Fields/Fields';
import { messages } from './StepThree.messages';
import { StepThreeProps } from './StepThree.types';

export const StepThree = memo<StepThreeProps>((props) => {
    const { fields = [] } = props;

    const filteredFields = useMemo(
        () => fields.filter((item) => ![...stepOneRenderedKeys, ...stepTwoRenderedKeys].includes(item.path)),
        [fields]
    );

    const fieldsBankDetails = useMemo(
        () =>
            fieldAppearanceBankDetails.reduce<backend.AirwallexBenefeciarySchemaField[]>((acc, appearanceField) => {
                const field = filteredFields.find((filteredField) => filteredField.path === appearanceField.path);

                if (field) {
                    acc.push(field);
                }

                return acc;
            }, []),
        [filteredFields]
    );

    const fieldsAddress = useMemo(
        () =>
            fieldAppearanceAddress.reduce<backend.AirwallexBenefeciarySchemaField[]>((acc, appearanceField) => {
                const field = filteredFields.find((filteredField) => filteredField.path === appearanceField.path);

                if (field) {
                    acc.push(field);
                }

                return acc;
            }, []),
        [filteredFields]
    );

    const fieldsMisc = useMemo(
        () =>
            filteredFields.filter((field) => {
                return (
                    !fieldAppearanceAddress.find(
                        (fieldAppearanceAddressItem) => fieldAppearanceAddressItem.path === field.path
                    ) && !fieldsBankDetails.find((fieldsBankDetailsItem) => fieldsBankDetailsItem.path === field.path)
                );
            }),
        [fieldsBankDetails, filteredFields]
    );

    return (
        <Flex spacing='32' direction='column'>
            <Flex direction='column'>
                <Text font='headline' fontSize='xxsmall'>
                    {messages.bankDetails}
                </Text>

                <Fields fields={fieldsBankDetails} />
            </Flex>

            <Flex direction='column'>
                <Text font='headline' fontSize='xxsmall'>
                    {messages.address}
                </Text>

                <Fields fields={fieldsAddress} />
            </Flex>

            <Flex direction='column'>
                {fieldsMisc.length > 0 && (
                    <>
                        <Text font='headline' fontSize='xxsmall'>
                            {messages.misc}
                        </Text>

                        <Fields fields={fieldsMisc} />
                    </>
                )}
            </Flex>
        </Flex>
    );
});

StepThree.displayName = 'StepThree';
